import { render, staticRenderFns } from "./PublicContact.vue?vue&type=template&id=07c0ab54&"
import script from "../scripts/publicContact.js?vue&type=script&lang=js&"
export * from "../scripts/publicContact.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports